module.exports = __webpack_public_path__ + "static/media/IMG_1955.587708aa.jpg";